import { useState } from 'react'
import { useReportBusy } from '@/console/state/useReportBusy'
import { PageHeading } from '@/console/ui/PageHeading'
import { TABS } from '@/console/shell/tabs'
import { GlobalRollbackPanel } from './GlobalRollbackPanel'
import { OriginRemapPanel } from './OriginRemapPanel'

const tab = TABS.find((t) => t.key === 'inb')!

/**
 * 입고 탭 — 반품 원주문 재매핑과 글로벌 입고확정 롤백·재확정.
 *
 * 두 조치 모두 응답을 놓치면 되돌릴 근거(before/after · 처리분 요약)를 잃는다. 어느 한 패널이라도
 * 제출 중이면 셸에 busy 를 알려 탭 전환을 막는다.
 */
export const InboundTab = ({ onBusyChange }: { onBusyChange?: (busy: boolean) => void }): JSX.Element => {
  const [originRemapBusy, setOriginRemapBusy] = useState(false)
  const [globalRollbackBusy, setGlobalRollbackBusy] = useState(false)
  useReportBusy(originRemapBusy || globalRollbackBusy, onBusyChange)

  return (
    <>
      <PageHeading title={tab.heading} sub={tab.sub} />
      <OriginRemapPanel onBusyChange={setOriginRemapBusy} />
      <GlobalRollbackPanel onBusyChange={setGlobalRollbackBusy} />
    </>
  )
}
